import { render } from "./VouchersPage.vue?vue&type=template&id=5225143f&scoped=true"
import script from "./VouchersPage.vue?vue&type=script&lang=js"
export * from "./VouchersPage.vue?vue&type=script&lang=js"

import "./VouchersPage.vue?vue&type=style&index=0&id=5225143f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5225143f"]])

export default __exports__